"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltySessionResponseToJSON = exports.LoyaltySessionResponseFromJSONTyped = exports.LoyaltySessionResponseFromJSON = void 0;
function LoyaltySessionResponseFromJSON(json) {
    return LoyaltySessionResponseFromJSONTyped(json, false);
}
exports.LoyaltySessionResponseFromJSON = LoyaltySessionResponseFromJSON;
function LoyaltySessionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sessionToken': json['sessionToken'],
    };
}
exports.LoyaltySessionResponseFromJSONTyped = LoyaltySessionResponseFromJSONTyped;
function LoyaltySessionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sessionToken': value.sessionToken,
    };
}
exports.LoyaltySessionResponseToJSON = LoyaltySessionResponseToJSON;
//# sourceMappingURL=LoyaltySessionResponse.js.map